import { Component, Input } from '@angular/core';
import { Observable } from 'rxjs';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'pt-html-help',
  template: `
    <!--    <div class='modal-header'>-->
    <!--      <h4 class='modal-title'>-->
    <!--        {{ title | async }}</h4>-->
    <!--    </div>-->
<!--    <div class='modal-header'>-->
<!--    -->
<!--    </div>-->
    <div class='modal-body'>
      <button type='button'
              style="
                    position: absolute;
                    right: 15px;
                    top: 15px;
                    padding: 0;"
              class='btn-close' aria-label='Close'
              (click)='activeModal.close(false)'>
      </button>
      <div [innerHTML]="help | async"></div>

    </div>

    <!--    <div class='modal-footer'>-->
    <!--      <button type='button'-->
    <!--              class='btn btn-outline-secondary btn-sm'-->
    <!--              (click)='activeModal.close(false);'>-->
    <!--        {{ 'BUTTON.CLOSE' | translate }}-->
    <!--      </button>-->
    <!--    </div>-->
  `,
  styles: [`

  `]
})
export class HtmlHelpDialogComponent {
  @Input() help: Observable<string>;
  constructor(public activeModal: NgbActiveModal) {}
}
